import gql from 'graphql-tag';

export const commercialOutageFields = gql`
  fragment CommercialOutageFields on CommercialOutage {
    id
    outageStartDate
    outageEndDate
    numberOfUnitsOnOutage
    numberOfTotalUnits
    aorId
    commercialOperatingAreaId
    commercialMarketAreaId
    notes
    createdBy
    createdAt
    updater
    updatedAt
    version
    CommercialFacility {
      id
      facilityName
      facilityId
    }
    AOR {
      id
      name
    }
    CommercialOperatingArea {
      id
      name
    }
    CommercialMarketArea {
      id
      name
    }
  }
`;

export const getCommercialOutage = gql`
  ${commercialOutageFields}
  query getCommercialOutage($id: ID!, $version: Int) {
    getCommercialOutage(id: $id, version: $version) {
      ...CommercialOutageFields
    }
  }
`;
